(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ev-product-options')) {
    class EvProductOptions extends HTMLElement {
      connectedCallback() {
        this.storeKey = 'ev-opts:' + this.dataset.productId;
        this.state = this.load();
        this.last = {};
        this.addEventListener('change', this.onChange);
        this.addEventListener('input', this.onChange);
        this.addEventListener('click', this.onClick);
        this.apply();
        // If the theme re-renders this part of the page (e.g. colour change), put the choices back.
        this.observer = new MutationObserver(() => this.apply());
        this.observer.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('input', this.onChange);
        this.removeEventListener('click', this.onClick);
        if (this.observer) this.observer.disconnect();
      }

      load() {
        try { return JSON.parse(sessionStorage.getItem(this.storeKey)) || {}; } catch (e) { return {}; }
      }

      save() {
        try { sessionStorage.setItem(this.storeKey, JSON.stringify(this.state)); } catch (e) {}
      }

      onChange = (event) => {
        const el = event.target;
        if (!(el instanceof HTMLElement) || !this.contains(el)) return;

        if (el.dataset && el.dataset.multi) {
          const name = el.dataset.multi;
          const chosen = this.multiBoxes(name).filter((b) => b.checked).map((b) => b.value);
          this.state[name] = chosen;
          this.syncHidden(name, chosen);
        } else if (el.type === 'radio') {
          if (el.checked) { this.state[el.name] = el.value; this.last[el.name] = el.value; }
        } else if (el.type === 'checkbox') {
          this.state[el.name] = el.checked ? el.value : '';
        } else if (el.name) {
          this.state[el.name] = el.value;
        }
        this.save();
      };

      // A selected radio button can be clicked again to clear it (when the field is not required).
      onClick = (event) => {
        const el = event.target;
        if (!(el instanceof HTMLInputElement) || el.type !== 'radio' || !this.contains(el)) return;
        if (el.required) return;
        if (el.checked && this.last[el.name] === el.value) {
          el.checked = false;
          this.last[el.name] = '';
          this.state[el.name] = '';
          this.save();
        }
      };

      multiBoxes(name) {
        return Array.from(this.querySelectorAll('input[type="checkbox"][data-multi]')).filter((b) => b.dataset.multi === name);
      }

      syncHidden(name, chosen) {
        const hidden = Array.from(this.querySelectorAll('input[data-multi-target]')).find((h) => h.name === name);
        if (hidden) {
          hidden.value = chosen.join(', ');
          // a disabled field is not sent with the form, so nothing is saved when nothing is ticked
          hidden.disabled = chosen.length === 0;
        }
      }

      apply() {
        const s = this.state;
        this.querySelectorAll('input, select, textarea').forEach((el) => {
          if (el.dataset && el.dataset.multi) {
            const arr = Array.isArray(s[el.dataset.multi]) ? s[el.dataset.multi] : [];
            el.checked = arr.indexOf(el.value) !== -1;
          } else if (el.type === 'radio') {
            if (el.name in s) { el.checked = s[el.name] === el.value; if (el.checked) this.last[el.name] = el.value; }
          } else if (el.type === 'checkbox') {
            if (el.name in s) el.checked = s[el.name] === el.value;
          } else if (el.name && el.type !== 'hidden' && el.name in s) {
            el.value = s[el.name];
          }
        });
        Object.keys(s).forEach((name) => { if (Array.isArray(s[name])) this.syncHidden(name, s[name]); });
      }
    }
    customElements.define('ev-product-options', EvProductOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
